export default [
  {
    id: 11,
    key: '11',
    value: '北京'
  },
  {
    id: 12,
    key: '12',
    value: '天津'
  },
  {
    id: 13,
    key: '13',
    value: '河北',
    children: [
      {
        id: 130100,
        key: '130100',
        value: '石家庄'
      },
      {
        id: 130200,
        key: '130200',
        value: '唐山'
      },
      {
        id: 130300,
        key: '130300',
        value: '秦皇岛'
      },
      {
        id: 130400,
        key: '130400',
        value: '邯郸'
      },
      {
        id: 130500,
        key: '130500',
        value: '邢台'
      },
      {
        id: 130600,
        key: '130600',
        value: '保定'
      },
      {
        id: 130700,
        key: '130700',
        value: '张家口'
      },
      {
        id: 130800,
        key: '130800',
        value: '承德'
      },
      {
        id: 130900,
        key: '130900',
        value: '沧州'
      },
      {
        id: 131000,
        key: '131000',
        value: '廊坊'
      },
      {
        id: 131100,
        key: '131100',
        value: '衡水'
      }
    ]
  },
  {
    id: 14,
    key: '14',
    value: '山西',
    children: [
      {
        id: 140100,
        key: '140100',
        value: '太原'
      },
      {
        id: 140200,
        key: '140200',
        value: '大同'
      },
      {
        id: 140300,
        key: '140300',
        value: '阳泉'
      },
      {
        id: 140400,
        key: '140400',
        value: '长治'
      },
      {
        id: 140500,
        key: '140500',
        value: '晋城'
      },
      {
        id: 140600,
        key: '140600',
        value: '朔州'
      },
      {
        id: 140700,
        key: '140700',
        value: '晋中'
      },
      {
        id: 140800,
        key: '140800',
        value: '运城'
      },
      {
        id: 140900,
        key: '140900',
        value: '忻州'
      },
      {
        id: 141000,
        key: '141000',
        value: '临汾'
      },
      {
        id: 141100,
        key: '141100',
        value: '吕梁'
      }
    ]
  },
  {
    id: 15,
    key: '15',
    value: '内蒙古',
    children: [
      {
        id: 150100,
        key: '150100',
        value: '呼和浩特'
      },
      {
        id: 150200,
        key: '150200',
        value: '包头'
      },
      {
        id: 150300,
        key: '150300',
        value: '乌海'
      },
      {
        id: 150400,
        key: '150400',
        value: '赤峰'
      },
      {
        id: 150500,
        key: '150500',
        value: '通辽'
      },
      {
        id: 150600,
        key: '150600',
        value: '鄂尔多斯'
      },
      {
        id: 150700,
        key: '150700',
        value: '呼伦贝尔'
      },
      {
        id: 150800,
        key: '150800',
        value: '巴彦淖尔'
      },
      {
        id: 150900,
        key: '150900',
        value: '乌兰察布'
      },
      {
        id: 152200,
        key: '152200',
        value: '兴安'
      },
      {
        id: 152500,
        key: '152500',
        value: '锡林郭勒'
      },
      {
        id: 152900,
        key: '152900',
        value: '阿拉善'
      }
    ]
  },
  {
    id: 21,
    key: '21',
    value: '辽宁',
    children: [
      {
        id: 210100,
        key: '210100',
        value: '沈阳'
      },
      {
        id: 210200,
        key: '210200',
        value: '大连'
      },
      {
        id: 210300,
        key: '210300',
        value: '鞍山'
      },
      {
        id: 210400,
        key: '210400',
        value: '抚顺'
      },
      {
        id: 210500,
        key: '210500',
        value: '本溪'
      },
      {
        id: 210600,
        key: '210600',
        value: '丹东'
      },
      {
        id: 210700,
        key: '210700',
        value: '锦州'
      },
      {
        id: 210800,
        key: '210800',
        value: '营口'
      },
      {
        id: 210900,
        key: '210900',
        value: '阜新'
      },
      {
        id: 211000,
        key: '211000',
        value: '辽阳'
      },
      {
        id: 211100,
        key: '211100',
        value: '盘锦'
      },
      {
        id: 211200,
        key: '211200',
        value: '铁岭'
      },
      {
        id: 211300,
        key: '211300',
        value: '朝阳'
      },
      {
        id: 211400,
        key: '211400',
        value: '葫芦岛'
      }
    ]
  },
  {
    id: 22,
    key: '22',
    value: '吉林',
    children: [
      {
        id: 220100,
        key: '220100',
        value: '长春'
      },
      {
        id: 220200,
        key: '220200',
        value: '吉林'
      },
      {
        id: 220300,
        key: '220300',
        value: '四平'
      },
      {
        id: 220400,
        key: '220400',
        value: '辽源'
      },
      {
        id: 220500,
        key: '220500',
        value: '通化'
      },
      {
        id: 220700,
        key: '220700',
        value: '松原'
      },
      {
        id: 220800,
        key: '220800',
        value: '白城'
      },
      {
        id: 222400,
        key: '222400',
        value: '延边'
      }
    ]
  },
  {
    id: 23,
    key: '23',
    value: '黑龙江',
    children: [
      {
        id: 230100,
        key: '230100',
        value: '哈尔滨'
      },
      {
        id: 230200,
        key: '230200',
        value: '齐齐哈尔'
      },
      {
        id: 230300,
        key: '230300',
        value: '鸡西'
      },
      {
        id: 230400,
        key: '230400',
        value: '鹤岗'
      },
      {
        id: 230500,
        key: '230500',
        value: '双鸭山'
      },
      {
        id: 230600,
        key: '230600',
        value: '大庆'
      },
      {
        id: 230700,
        key: '230700',
        value: '伊春'
      },
      {
        id: 230800,
        key: '230800',
        value: '佳木斯'
      },
      {
        id: 230900,
        key: '230900',
        value: '七台河'
      },
      {
        id: 231000,
        key: '231000',
        value: '牡丹江'
      },
      {
        id: 231100,
        key: '231100',
        value: '黑河'
      },
      {
        id: 231200,
        key: '231200',
        value: '绥化'
      },
      {
        id: 232700,
        key: '232700',
        value: '大兴安岭'
      }
    ]
  },
  {
    id: 31,
    key: '31',
    value: '上海'
  },
  {
    id: 32,
    key: '32',
    value: '江苏',
    children: [
      {
        id: 320100,
        key: '320100',
        value: '南京'
      },
      {
        id: 320200,
        key: '320200',
        value: '无锡'
      },
      {
        id: 320300,
        key: '320300',
        value: '徐州'
      },
      {
        id: 320400,
        key: '320400',
        value: '常州'
      },
      {
        id: 320500,
        key: '320500',
        value: '苏州'
      },
      {
        id: 320600,
        key: '320600',
        value: '南通'
      },
      {
        id: 320700,
        key: '320700',
        value: '连云港'
      },
      {
        id: 320800,
        key: '320800',
        value: '淮安'
      },
      {
        id: 320900,
        key: '320900',
        value: '盐城'
      },
      {
        id: 321000,
        key: '321000',
        value: '扬州'
      },
      {
        id: 321100,
        key: '321100',
        value: '镇江'
      },
      {
        id: 321200,
        key: '321200',
        value: '泰州'
      },
      {
        id: 321300,
        key: '321300',
        value: '宿迁'
      }
    ]
  },
  {
    id: 33,
    key: '33',
    value: '浙江',
    children: [
      {
        id: 330100,
        key: '330100',
        value: '杭州'
      },
      {
        id: 330200,
        key: '330200',
        value: '宁波'
      },
      {
        id: 330300,
        key: '330300',
        value: '温州'
      },
      {
        id: 330400,
        key: '330400',
        value: '嘉兴'
      },
      {
        id: 330500,
        key: '330500',
        value: '湖州'
      },
      {
        id: 330600,
        key: '330600',
        value: '绍兴'
      },
      {
        id: 330700,
        key: '330700',
        value: '金华'
      },
      {
        id: 330800,
        key: '330800',
        value: '衢州'
      },
      {
        id: 330900,
        key: '330900',
        value: '舟山'
      },
      {
        id: 331000,
        key: '331000',
        value: '台州'
      },
      {
        id: 331100,
        key: '331100',
        value: '丽水'
      }
    ]
  },
  {
    id: 34,
    key: '34',
    value: '安徽',
    children: [
      {
        id: 340100,
        key: '340100',
        value: '合肥'
      },
      {
        id: 340200,
        key: '340200',
        value: '芜湖'
      },
      {
        id: 340300,
        key: '340300',
        value: '蚌埠'
      },
      {
        id: 340400,
        key: '340400',
        value: '淮南'
      },
      {
        id: 340500,
        key: '340500',
        value: '马鞍山'
      },
      {
        id: 340600,
        key: '340600',
        value: '淮北'
      },
      {
        id: 340700,
        key: '340700',
        value: '铜陵'
      },
      {
        id: 340800,
        key: '340800',
        value: '安庆'
      },
      {
        id: 341000,
        key: '341000',
        value: '黄山'
      },
      {
        id: 341100,
        key: '341100',
        value: '滁州'
      },
      {
        id: 341200,
        key: '341200',
        value: '阜阳'
      },
      {
        id: 341300,
        key: '341300',
        value: '宿州'
      },
      {
        id: 341500,
        key: '341500',
        value: '六安'
      },
      {
        id: 341600,
        key: '341600',
        value: '亳州'
      },
      {
        id: 341700,
        key: '341700',
        value: '池州'
      },
      {
        id: 341800,
        key: '341800',
        value: '宣城'
      }
    ]
  },
  {
    id: 35,
    key: '35',
    value: '福建',
    children: [
      {
        id: 350100,
        key: '350100',
        value: '福州'
      },
      {
        id: 350200,
        key: '350200',
        value: '厦门'
      },
      {
        id: 350300,
        key: '350300',
        value: '莆田'
      },
      {
        id: 350400,
        key: '350400',
        value: '三明'
      },
      {
        id: 350500,
        key: '350500',
        value: '泉州'
      },
      {
        id: 350600,
        key: '350600',
        value: '漳州'
      },
      {
        id: 350700,
        key: '350700',
        value: '南平'
      },
      {
        id: 350800,
        key: '350800',
        value: '龙岩'
      },
      {
        id: 350900,
        key: '350900',
        value: '宁德'
      }
    ]
  },
  {
    id: 36,
    key: '36',
    value: '江西',
    children: [
      {
        id: 360100,
        key: '360100',
        value: '南昌'
      },
      {
        id: 360200,
        key: '360200',
        value: '景德镇'
      },
      {
        id: 360300,
        key: '360300',
        value: '萍乡'
      },
      {
        id: 360400,
        key: '360400',
        value: '九江'
      },
      {
        id: 360500,
        key: '360500',
        value: '新余'
      },
      {
        id: 360600,
        key: '360600',
        value: '鹰潭'
      },
      {
        id: 360700,
        key: '360700',
        value: '赣州'
      },
      {
        id: 360800,
        key: '360800',
        value: '吉安'
      },
      {
        id: 360900,
        key: '360900',
        value: '宜春'
      },
      {
        id: 361000,
        key: '361000',
        value: '抚州'
      },
      {
        id: 361100,
        key: '361100',
        value: '上饶'
      }
    ]
  },
  {
    id: 37,
    key: '37',
    value: '山东',
    children: [
      {
        id: 370100,
        key: '370100',
        value: '济南'
      },
      {
        id: 370200,
        key: '370200',
        value: '青岛'
      },
      {
        id: 370300,
        key: '370300',
        value: '淄博'
      },
      {
        id: 370400,
        key: '370400',
        value: '枣庄'
      },
      {
        id: 370500,
        key: '370500',
        value: '东营'
      },
      {
        id: 370600,
        key: '370600',
        value: '烟台'
      },
      {
        id: 370700,
        key: '370700',
        value: '潍坊'
      },
      {
        id: 370800,
        key: '370800',
        value: '济宁'
      },
      {
        id: 370900,
        key: '370900',
        value: '泰安'
      },
      {
        id: 371000,
        key: '371000',
        value: '威海'
      },
      {
        id: 371100,
        key: '371100',
        value: '日照'
      },
      {
        id: 371200,
        key: '371200',
        value: '莱芜'
      },
      {
        id: 371300,
        key: '371300',
        value: '临沂'
      },
      {
        id: 371400,
        key: '371400',
        value: '德州'
      },
      {
        id: 371500,
        key: '371500',
        value: '聊城'
      },
      {
        id: 371600,
        key: '371600',
        value: '滨州'
      },
      {
        id: 371700,
        key: '371700',
        value: '菏泽'
      }
    ]
  },
  {
    id: 41,
    key: '41',
    value: '河南',
    children: [
      {
        id: 410100,
        key: '410100',
        value: '郑州'
      },
      {
        id: 410200,
        key: '410200',
        value: '开封'
      },
      {
        id: 410300,
        key: '410300',
        value: '洛阳'
      },
      {
        id: 410400,
        key: '410400',
        value: '平顶山'
      },
      {
        id: 410500,
        key: '410500',
        value: '安阳'
      },
      {
        id: 410600,
        key: '410600',
        value: '鹤壁'
      },
      {
        id: 410700,
        key: '410700',
        value: '新乡'
      },
      {
        id: 410800,
        key: '410800',
        value: '焦作'
      },
      {
        id: 410900,
        key: '410900',
        value: '濮阳'
      },
      {
        id: 411000,
        key: '411000',
        value: '许昌'
      },
      {
        id: 411100,
        key: '411100',
        value: '漯河'
      },
      {
        id: 411200,
        key: '411200',
        value: '三门峡'
      },
      {
        id: 411300,
        key: '411300',
        value: '南阳'
      },
      {
        id: 411400,
        key: '411400',
        value: '商丘'
      },
      {
        id: 411500,
        key: '411500',
        value: '信阳'
      },
      {
        id: 411600,
        key: '411600',
        value: '周口'
      },
      {
        id: 411700,
        key: '411700',
        value: '驻马店'
      },
      {
        id: 419001,
        key: '419001',
        value: '济源'
      }
    ]
  },
  {
    id: 42,
    key: '42',
    value: '湖北',
    children: [
      {
        id: 420100,
        key: '420100',
        value: '武汉'
      },
      {
        id: 420200,
        key: '420200',
        value: '黄石'
      },
      {
        id: 420300,
        key: '420300',
        value: '十堰'
      },
      {
        id: 420500,
        key: '420500',
        value: '宜昌'
      },
      {
        id: 420600,
        key: '420600',
        value: '襄阳'
      },
      {
        id: 420700,
        key: '420700',
        value: '鄂州'
      },
      {
        id: 420800,
        key: '420800',
        value: '荆门'
      },
      {
        id: 420900,
        key: '420900',
        value: '孝感'
      },
      {
        id: 421000,
        key: '421000',
        value: '荆州'
      },
      {
        id: 421100,
        key: '421100',
        value: '黄冈'
      },
      {
        id: 421200,
        key: '421200',
        value: '咸宁'
      },
      {
        id: 421300,
        key: '421300',
        value: '随州'
      },
      {
        id: 422800,
        key: '422800',
        value: '恩施'
      },
      {
        id: 429004,
        key: '429004',
        value: '仙桃'
      },
      {
        id: 429005,
        key: '429005',
        value: '潜江'
      },
      {
        id: 429006,
        key: '429006',
        value: '天门'
      },
      {
        id: 429021,
        key: '429021',
        value: '神农架'
      }
    ]
  },
  {
    id: 43,
    key: '43',
    value: '湖南',
    children: [
      {
        id: 430100,
        key: '430100',
        value: '长沙'
      },
      {
        id: 430200,
        key: '430200',
        value: '株洲'
      },
      {
        id: 430300,
        key: '430300',
        value: '湘潭'
      },
      {
        id: 430400,
        key: '430400',
        value: '衡阳'
      },
      {
        id: 430500,
        key: '430500',
        value: '邵阳'
      },
      {
        id: 430600,
        key: '430600',
        value: '岳阳'
      },
      {
        id: 430700,
        key: '430700',
        value: '常德'
      },
      {
        id: 430800,
        key: '430800',
        value: '张家界'
      },
      {
        id: 430900,
        key: '430900',
        value: '益阳'
      },
      {
        id: 431000,
        key: '431000',
        value: '郴州'
      },
      {
        id: 431100,
        key: '431100',
        value: '永州'
      },
      {
        id: 431200,
        key: '431200',
        value: '怀化'
      },
      {
        id: 431300,
        key: '431300',
        value: '娄底'
      },
      {
        id: 433100,
        key: '433100',
        value: '湘西'
      }
    ]
  },
  {
    id: 44,
    key: '44',
    value: '广东',
    children: [
      {
        id: 440100,
        key: '440100',
        value: '广州'
      },
      {
        id: 440200,
        key: '440200',
        value: '韶关'
      },
      {
        id: 440300,
        key: '440300',
        value: '深圳'
      },
      {
        id: 440400,
        key: '440400',
        value: '珠海'
      },
      {
        id: 440500,
        key: '440500',
        value: '汕头'
      },
      {
        id: 440600,
        key: '440600',
        value: '佛山'
      },
      {
        id: 440700,
        key: '440700',
        value: '江门'
      },
      {
        id: 440800,
        key: '440800',
        value: '湛江'
      },
      {
        id: 440900,
        key: '440900',
        value: '茂名'
      },
      {
        id: 441200,
        key: '441200',
        value: '肇庆'
      },
      {
        id: 441300,
        key: '441300',
        value: '惠州'
      },
      {
        id: 441400,
        key: '441400',
        value: '梅州'
      },
      {
        id: 441500,
        key: '441500',
        value: '汕尾'
      },
      {
        id: 441600,
        key: '441600',
        value: '河源'
      },
      {
        id: 441700,
        key: '441700',
        value: '阳江'
      },
      {
        id: 441800,
        key: '441800',
        value: '清远'
      },
      {
        id: 441900,
        key: '441900',
        value: '东莞'
      },
      {
        id: 442000,
        key: '442000',
        value: '中山'
      },
      {
        id: 445100,
        key: '445100',
        value: '潮州'
      },
      {
        id: 445200,
        key: '445200',
        value: '揭阳'
      },
      {
        id: 445300,
        key: '445300',
        value: '云浮'
      }
    ]
  },
  {
    id: 45,
    key: '45',
    value: '广西',
    children: [
      {
        id: 450100,
        key: '450100',
        value: '南宁'
      },
      {
        id: 450200,
        key: '450200',
        value: '柳州'
      },
      {
        id: 450300,
        key: '450300',
        value: '桂林'
      },
      {
        id: 450400,
        key: '450400',
        value: '梧州'
      },
      {
        id: 450500,
        key: '450500',
        value: '北海'
      },
      {
        id: 450600,
        key: '450600',
        value: '防城港'
      },
      {
        id: 450700,
        key: '450700',
        value: '钦州'
      },
      {
        id: 450800,
        key: '450800',
        value: '贵港'
      },
      {
        id: 450900,
        key: '450900',
        value: '玉林'
      },
      {
        id: 451000,
        key: '451000',
        value: '百色'
      },
      {
        id: 451100,
        key: '451100',
        value: '贺州'
      },
      {
        id: 451200,
        key: '451200',
        value: '河池'
      },
      {
        id: 451300,
        key: '451300',
        value: '来宾'
      },
      {
        id: 451400,
        key: '451400',
        value: '崇左'
      }
    ]
  },
  {
    id: 46,
    key: '46',
    value: '海南',
    children: [
      {
        id: 460100,
        key: '460100',
        value: '海口'
      },
      {
        id: 460200,
        key: '460200',
        value: '海棠'
      },
      {
        id: 460300,
        key: '460300',
        value: '三沙'
      },
      {
        id: 460400,
        key: '460400',
        value: '儋州'
      },
      {
        id: 469001,
        key: '469001',
        value: '五指山'
      },
      {
        id: 469002,
        key: '469002',
        value: '琼海'
      },
      {
        id: 469005,
        key: '469005',
        value: '文昌'
      },
      {
        id: 469006,
        key: '469006',
        value: '万宁'
      },
      {
        id: 469007,
        key: '469007',
        value: '东方'
      },
      {
        id: 469021,
        key: '469021',
        value: '定安'
      },
      {
        id: 469022,
        key: '469022',
        value: '屯昌'
      },
      {
        id: 469023,
        key: '469023',
        value: '澄迈'
      },
      {
        id: 469024,
        key: '469024',
        value: '临高'
      },
      {
        id: 469025,
        key: '469025',
        value: '白沙'
      },
      {
        id: 469026,
        key: '469026',
        value: '昌江'
      },
      {
        id: 469027,
        key: '469027',
        value: '乐东'
      },
      {
        id: 469028,
        key: '469028',
        value: '陵水'
      },
      {
        id: 469029,
        key: '469029',
        value: '保亭'
      },
      {
        id: 469030,
        key: '469030',
        value: '琼中'
      }
    ]
  },
  {
    id: 50,
    key: '50',
    value: '重庆'
  },
  {
    id: 51,
    key: '51',
    value: '四川',
    children: [
      {
        id: 510100,
        key: '510100',
        value: '成都'
      },
      {
        id: 510300,
        key: '510300',
        value: '自贡'
      },
      {
        id: 510400,
        key: '510400',
        value: '攀枝花'
      },
      {
        id: 510500,
        key: '510500',
        value: '泸州'
      },
      {
        id: 510600,
        key: '510600',
        value: '德阳'
      },
      {
        id: 510700,
        key: '510700',
        value: '绵阳'
      },
      {
        id: 510800,
        key: '510800',
        value: '广元'
      },
      {
        id: 510900,
        key: '510900',
        value: '遂宁'
      },
      {
        id: 511000,
        key: '511000',
        value: '内江'
      },
      {
        id: 511100,
        key: '511100',
        value: '乐山'
      },
      {
        id: 511300,
        key: '511300',
        value: '南充'
      },
      {
        id: 511400,
        key: '511400',
        value: '眉山'
      },
      {
        id: 511500,
        key: '511500',
        value: '宜宾'
      },
      {
        id: 511600,
        key: '511600',
        value: '广安'
      },
      {
        id: 511700,
        key: '511700',
        value: '达州'
      },
      {
        id: 511800,
        key: '511800',
        value: '雅安'
      },
      {
        id: 511900,
        key: '511900',
        value: '巴中'
      },
      {
        id: 512000,
        key: '512000',
        value: '资阳'
      },
      {
        id: 513200,
        key: '513200',
        value: '阿坝'
      },
      {
        id: 513300,
        key: '513300',
        value: '甘孜'
      },
      {
        id: 513400,
        key: '513400',
        value: '凉山'
      }
    ]
  },
  {
    id: 52,
    key: '52',
    value: '贵州',
    children: [
      {
        id: 520100,
        key: '520100',
        value: '贵阳'
      },
      {
        id: 520200,
        key: '520200',
        value: '六盘水'
      },
      {
        id: 520300,
        key: '520300',
        value: '遵义'
      },
      {
        id: 520400,
        key: '520400',
        value: '安顺'
      },
      {
        id: 520500,
        key: '520500',
        value: '毕节'
      },
      {
        id: 520600,
        key: '520600',
        value: '铜仁'
      },
      {
        id: 522600,
        key: '522600',
        value: '黔东南'
      },
      {
        id: 522700,
        key: '522700',
        value: '黔南'
      }
    ]
  },
  {
    id: 53,
    key: '53',
    value: '云南',
    children: [
      {
        id: 530100,
        key: '530100',
        value: '昆明'
      },
      {
        id: 530300,
        key: '530300',
        value: '曲靖'
      },
      {
        id: 530400,
        key: '530400',
        value: '玉溪'
      },
      {
        id: 530500,
        key: '530500',
        value: '保山'
      },
      {
        id: 530600,
        key: '530600',
        value: '昭通'
      },
      {
        id: 530700,
        key: '530700',
        value: '丽江'
      },
      {
        id: 530800,
        key: '530800',
        value: '普洱'
      },
      {
        id: 530900,
        key: '530900',
        value: '临沧'
      },
      {
        id: 532300,
        key: '532300',
        value: '楚雄'
      },
      {
        id: 532500,
        key: '532500',
        value: '红河'
      },
      {
        id: 532600,
        key: '532600',
        value: '文山'
      },
      {
        id: 532800,
        key: '532800',
        value: '西双版纳'
      },
      {
        id: 532900,
        key: '532900',
        value: '大理'
      },
      {
        id: 533100,
        key: '533100',
        value: '德宏'
      },
      {
        id: 533300,
        key: '533300',
        value: '怒江'
      },
      {
        id: 533400,
        key: '533400',
        value: '迪庆'
      }
    ]
  },
  {
    id: 54,
    key: '54',
    value: '西藏',
    children: [
      {
        id: 540100,
        key: '540100',
        value: '拉萨'
      },
      {
        id: 540200,
        key: '540200',
        value: '日喀则'
      },
      {
        id: 540300,
        key: '540300',
        value: '昌都'
      },
      {
        id: 540400,
        key: '540400',
        value: '林芝'
      },
      {
        id: 540500,
        key: '540500',
        value: '山南'
      },
      {
        id: 542400,
        key: '542400',
        value: '那曲'
      },
      {
        id: 542500,
        key: '542500',
        value: '阿里'
      }
    ]
  },
  {
    id: 61,
    key: '61',
    value: '陕西',
    children: [
      {
        id: 610100,
        key: '610100',
        value: '西安'
      },
      {
        id: 610200,
        key: '610200',
        value: '铜川'
      },
      {
        id: 610300,
        key: '610300',
        value: '宝鸡'
      },
      {
        id: 610400,
        key: '610400',
        value: '咸阳'
      },
      {
        id: 610500,
        key: '610500',
        value: '渭南'
      },
      {
        id: 610600,
        key: '610600',
        value: '延安'
      },
      {
        id: 610700,
        key: '610700',
        value: '汉中'
      },
      {
        id: 610800,
        key: '610800',
        value: '榆林'
      },
      {
        id: 610900,
        key: '610900',
        value: '安康'
      },
      {
        id: 611000,
        key: '611000',
        value: '商洛'
      }
    ]
  },
  {
    id: 62,
    key: '62',
    value: '甘肃',
    children: [
      {
        id: 620100,
        key: '620100',
        value: '兰州'
      },
      {
        id: 620200,
        key: '620200',
        value: '嘉峪关'
      },
      {
        id: 620300,
        key: '620300',
        value: '金昌'
      },
      {
        id: 620400,
        key: '620400',
        value: '白银'
      },
      {
        id: 620500,
        key: '620500',
        value: '天水'
      },
      {
        id: 620600,
        key: '620600',
        value: '武威'
      },
      {
        id: 620700,
        key: '620700',
        value: '张掖'
      },
      {
        id: 620800,
        key: '620800',
        value: '平凉'
      },
      {
        id: 620900,
        key: '620900',
        value: '酒泉'
      },
      {
        id: 621000,
        key: '621000',
        value: '庆阳'
      },
      {
        id: 621100,
        key: '621100',
        value: '定西'
      },
      {
        id: 621200,
        key: '621200',
        value: '陇南'
      },
      {
        id: 622900,
        key: '622900',
        value: '临夏'
      },
      {
        id: 623000,
        key: '623000',
        value: '甘南'
      }
    ]
  },
  {
    id: 63,
    key: '63',
    value: '青海',
    children: [
      {
        id: 630100,
        key: '630100',
        value: '西宁'
      },
      {
        id: 630200,
        key: '630200',
        value: '海东'
      },
      {
        id: 632200,
        key: '632200',
        value: '黄南'
      },
      {
        id: 632300,
        key: '632300',
        value: '黄南'
      },
      {
        id: 632500,
        key: '632500',
        value: '海南'
      },
      {
        id: 632600,
        key: '632600',
        value: '果洛'
      },
      {
        id: 632700,
        key: '632700',
        value: '玉树'
      },
      {
        id: 632800,
        key: '632800',
        value: '海西'
      }
    ]
  },
  {
    id: 64,
    key: '64',
    value: '宁夏',
    children: [
      {
        id: 640100,
        key: '640100',
        value: '银川'
      },
      {
        id: 640200,
        key: '640200',
        value: '石嘴山'
      },
      {
        id: 640300,
        key: '640300',
        value: '吴忠'
      },
      {
        id: 640400,
        key: '640400',
        value: '固原'
      },
      {
        id: 640500,
        key: '640500',
        value: '中卫'
      }
    ]
  },
  {
    id: 65,
    key: '65',
    value: '新疆',
    children: [
      {
        id: 650100,
        key: '650100',
        value: '乌鲁木齐'
      },
      {
        id: 650200,
        key: '650200',
        value: '克拉玛依'
      },
      {
        id: 650400,
        key: '650400',
        value: '吐鲁番'
      },
      {
        id: 650500,
        key: '650500',
        value: '哈密'
      },
      {
        id: 652300,
        key: '652300',
        value: '昌吉'
      },
      {
        id: 652700,
        key: '652700',
        value: '博尔塔拉'
      },
      {
        id: 652800,
        key: '652800',
        value: '巴音郭楞'
      },
      {
        id: 652900,
        key: '652900',
        value: '阿克苏'
      },
      {
        id: 653000,
        key: '653000',
        value: '克孜勒苏'
      },
      {
        id: 653100,
        key: '653100',
        value: '喀什'
      },
      {
        id: 653200,
        key: '653200',
        value: '和田'
      },
      {
        id: 654000,
        key: '654000',
        value: '伊犁'
      },
      {
        id: 654200,
        key: '654200',
        value: '塔城'
      },
      {
        id: 654300,
        key: '654300',
        value: '阿勒泰'
      },
      {
        id: 659001,
        key: '659001',
        value: '石河子'
      },
      {
        id: 659002,
        key: '659002',
        value: '阿拉尔'
      },
      {
        id: 659003,
        key: '659003',
        value: '图木舒克'
      },
      {
        id: 659004,
        key: '659004',
        value: '五家渠'
      },
      {
        id: 659005,
        key: '659005',
        value: '北屯'
      },
      {
        id: 659006,
        key: '659006',
        value: '铁门关'
      },
      {
        id: 659007,
        key: '659007',
        value: '双河'
      },
      {
        id: 659008,
        key: '659008',
        value: '可克达拉'
      }
    ]
  },
  {
    id: 71,
    key: '71',
    value: '台湾'
  },
  {
    id: 81,
    key: '81',
    value: '香港'
  },
  {
    id: 82,
    key: '82',
    value: '澳门'
  }
]
